import React from 'react'

export const Tabs = () => {
  return <div>Tabs</div>
}
